<template>
  <div>
    <el-dialog
      title="选择采集对象"
      :visible.sync="visible"
      :width="'800px'"
      :style="{ zIndex: 10000 }"
    >
      <!-- <el-tabs
        v-if="collect_type == 1"
        v-model="showType"
        type="card"
        @tab-click="handleClick"
      > -->
      <div v-if="collect_type == 1">
        <div v-if="$store.state.companyInfo.webscrap_is_new == 1">
          <div class="view-filter">
            <el-form ref="form" :inline="true" :model="form" layout="inline">
              <!--              <el-form-item label="省市" prop="">-->
              <!--                <el-select-->
              <!--                  style="width: 150px"-->
              <!--                  v-model="form.province_id"-->
              <!--                  placeholder="请选择"-->
              <!--                >-->
              <!--                  <el-option-->
              <!--                    v-for="item in regionList"-->
              <!--                    :label="item.region_name"-->
              <!--                    :value="item.region_id"-->
              <!--                  ></el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item label="档案类型" prop="">-->
              <!--                <el-select-->
              <!--                  style="width: 150px"-->
              <!--                  v-model="form.cls"-->
              <!--                  placeholder="请选择"-->
              <!--                  size="small"-->
              <!--                >-->
              <!--                  <el-option label="配送商" :value="4"> </el-option>-->
              <!--                  <el-option label="连锁总部" :value="3"> </el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->
              <el-form-item>
                <el-input
                  v-model="form.search_text"
                  class="search-text"
                  size="small"
                  style="width: 280px; margin-top: 2%"
                  placeholder="请输入档案编码/名称"
                >
                  <el-button slot="append" @click="onSearch">查找</el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="box left">
              <div class="header">未选：{{ left.length }}</div>
              <div class="list-body">
                <ul class="list-content">
                  <li class="list-item list-header">
                    <span>档案编码</span>
                    <span>档案名称</span>
                  </li>
                  <li
                    class="list-item"
                    v-for="(item, index) in left"
                    :key="`new-left-${index}-${item.client_id || ''}-${item.client_code || ''}`"
                    @click="leftSelect(item.client_id)"
                  >
                    <span>{{ item.client_code }}</span>
                    <span>{{ item.client_name }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="box middle">
              <el-button
                type="primary"
                :style="buttonStyle"
                :size="'small'"
                @click="selectAll"
                :disabled="selectedAll"
              >
                全选
              </el-button>
              <el-button
                type="primary"
                :style="buttonOneStyle"
                :size="'small'"
                @click="removeAll"
              >
                清空
              </el-button>
            </div>
            <div class="box right">
              <div class="header">
                已选：{{
                  right.length == 1 && right[0].client_name == "全部"
                    ? right[0].client_id.length
                    : right.length
                }}
              </div>
              <div class="list-body">
                <ul class="list-content">
                  <li class="list-item list-header right">
                    <span>档案编码</span>
                    <span>档案名称</span>
                  </li>
                  <li
                    class="list-item right"
                    v-for="(item, index) in right"
                    :key="`right-${item.client_id ? (Array.isArray(item.client_id) ? `all-${index}` : `single-${item.client_id}`) : `item-${index}`}-${item.client_code || index}`"
                    style="display: flex"
                  >
                    <span>{{ item.client_code }}</span>
                    <span>{{ item.client_name }}</span>
                    <i
                      style="
                        cursor: pointer;
                        position: relative;
                        left: 21px;
                        top: 11px;
                      "
                      class="el-icon-close"
                      @click="rightDelete(item)"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- v-if="totalPage > 1" -->

          <el-pagination
            background
            @current-change="onChangePage"
            :current-page="currentPage"
            :pageSize="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
            style="margin-top: 10px"
          >
          </el-pagination>
<!-- 
          <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span> -->
        </div>
        <div v-if="$store.state.companyInfo.webscrap_is_new == 0">
          <div class="view-filter">
            <el-form ref="form" :inline="true" :model="form" layout="inline">
              <!--              <el-form-item label="省市" prop="">-->
              <!--                <el-select-->
              <!--                  style="width: 150px"-->
              <!--                  v-model="form.province_id"-->
              <!--                  placeholder="请选择"-->
              <!--                >-->
              <!--                  <el-option label="全部" value=""></el-option>-->
              <!--                  <el-option-->
              <!--                    v-for="item in regionList"-->
              <!--                    :label="item.region_name"-->
              <!--                    :value="item.region_id"-->
              <!--                  ></el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item label="档案类型" prop="">-->
              <!--                <el-select-->
              <!--                  style="width: 150px"-->
              <!--                  v-model="form.cls"-->
              <!--                  placeholder="请选择"-->
              <!--                  size="small"-->
              <!--                >-->
              <!--                  <el-option label="配送商" :value="4"> </el-option>-->
              <!--                  <el-option label="连锁总部" :value="3"> </el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->
              <el-form-item>
                <el-input
                  v-model="form.search_text"
                  class="search-text"
                  size="small"
                  style="width: 280px; margin-top: 2%"
                  placeholder="请输入档案编码/名称"
                >
                  <el-button slot="append" @click="onSearch">查找</el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="box left">
              <div class="header">未选：{{ left.length }}</div>
              <div class="list-body">
                <ul class="list-content">
                  <li class="list-item list-header">
                    <span>档案编码</span>
                    <span>档案名称</span>
                  </li>
                  <li
                    class="list-item"
                    v-for="(item, index) in left"
                    :key="`old-left-${index}-${item.client_id || ''}-${item.broker_code || ''}`"
                    @click="leftSelect(item.client_id)"
                  >
                    <span>{{ item.broker_code }}</span>
                    <span>{{ item.client_name }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="box middle">
              <el-button
                type="primary"
                :style="buttonStyle"
                :size="'small'"
                @click="selectAll"
                :disabled="selectedAll"
              >
                全选
              </el-button>
              <el-button
                type="primary"
                :style="buttonOneStyle"
                :size="'small'"
                @click="removeAll"
              >
                清空
              </el-button>
            </div>
            <div class="box right">
              <div class="header">
                已选：{{
                  right.length == 1 && right[0].client_name == "全部"
                    ? right[0].client_id.length
                    : right.length
                }}
              </div>
              <div class="list-body">
                <ul class="list-content">
                  <li class="list-item list-header right">
                    <span>档案编码</span>
                    <span>档案名称</span>
                  </li>
                  <li
                    class="list-item right"
                    v-for="(item, index) in right"
                    :key="`right-${item.client_id ? (Array.isArray(item.client_id) ? `all-${index}` : `single-${item.client_id}`) : `item-${index}`}-${item.broker_code || index}`"
                    style="display: flex"
                  >
                    <span>{{ item.broker_code }}</span>
                    <span>{{ item.client_name }}</span>
                    <i
                      style="
                        cursor: pointer;
                        position: relative;
                        left: 21px;
                        top: 11px;
                      "
                      class="el-icon-close"
                      @click="rightDelete(item)"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <el-pagination
            background
            @current-change="onChangePage"
            :current-page="currentPage"
            :pageSize="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
            style="margin-top: 10px"
          >
          </el-pagination>
          <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
        </div>
      </div>
      <!-- <el-tab-pane label="新流程" name="new">

        </el-tab-pane> -->
      <!-- <el-tab-pane label="旧流程" name="old">

        </el-tab-pane> -->
      <!-- </el-tabs> -->
      <div v-else>
        <div class="view-filter">
          <el-form ref="form" :inline="true" :model="form" layout="inline">
            <!--            <el-form-item label="省市" prop="">-->
            <!--              <el-select-->
            <!--                style="width: 150px"-->
            <!--                v-model="form.province_id"-->
            <!--                placeholder="请选择"-->
            <!--              >-->
            <!--                <el-option-->
            <!--                  v-for="item in regionList"-->
            <!--                  :label="item.region_name"-->
            <!--                  :value="item.region_id"-->
            <!--                ></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="档案类型" prop="">-->
            <!--              <el-select-->
            <!--                style="width: 150px"-->
            <!--                v-model="form.cls"-->
            <!--                placeholder="请选择"-->
            <!--                size="small"-->
            <!--              >-->
            <!--                <el-option label="配送商" :value="4"> </el-option>-->
            <!--                <el-option label="连锁总部" :value="3"> </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item>
              <el-input
                v-model="form.search_text"
                class="search-text"
                size="small"
                style="width: 280px; margin-top: 2%"
                placeholder="请输入档案编码/名称"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div class="box left">
            <div class="header">未选：{{ left.length }}</div>
            <div class="list-body">
              <ul class="list-content">
                <li class="list-item list-header">
                  <span>档案编码</span>
                  <span>档案名称</span>
                </li>
                <li
                  class="list-item"
                  v-for="(item, index) in left"
                  :key="`ftp-left-${index}-${item.client_id || ''}-${item.client_code || ''}`"
                  @click="leftSelect(item.client_id)"
                >
                  <span>{{ item.client_code }}</span>
                  <span>{{ item.client_name }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="box middle">
            <el-button
              type="primary"
              :style="buttonStyle"
              :size="'small'"
              @click="selectAll"
              :disabled="selectedAll"
            >
              全选
            </el-button>
            <el-button
              type="primary"
              :style="buttonOneStyle"
              :size="'small'"
              @click="removeAll"
            >
              清空
            </el-button>
          </div>
          <div class="box right">
            <div class="header">
              已选：{{
                right.length == 1 && right[0].client_name == "全部"
                  ? right[0].client_id.length
                  : right.length
              }}
            </div>
            <div class="list-body">
              <ul class="list-content">
                <li class="list-item list-header right">
                  <span>档案编码</span>
                  <span>档案名称</span>
                </li>
                <li
                  class="list-item right"
                  v-for="(item, index) in right"
                  :key="`right-${item.client_id ? (Array.isArray(item.client_id) ? `all-${index}` : `single-${item.client_id}`) : `item-${index}`}-${item.client_code || index}`"
                  style="display: flex"
                >
                  <span>{{ item.client_code }}</span>
                  <span>{{ item.client_name }}</span>
                  <i
                    style="
                      cursor: pointer;
                      position: relative;
                      left: 21px;
                      top: 11px;
                    "
                    class="el-icon-close"
                    @click="rightDelete(item)"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <el-pagination
          background
          @current-change="onChangePage"
          :current-page="currentPage"
          :pageSize="20"
          layout="prev, pager, next, jumper"
          :total="totalCount"
          style="margin-top: 10px"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cencel">取 消</el-button>
        <el-button type="primary" @click="save" :disabled="right.length === 0"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  SplitgetSplitFileInfo,
  ftpPage,
  regionList,
  getClientPage,
} from "@/api/index";

export default {
  name: "SelectSummyModal",
  beforeCreate() {},
  data() {
    return {
      buttonStyle: {
        display: "block",
        marginBottom: "4px",
      },
      buttonOneStyle: {
        display: "block",
        marginBottom: "4px",
        marginLeft: "1px",
        marginTOP: "10px",
      },
      searchText: "",
      visible: false,
      left: [{ client_id: "" }],
      right: [{ client_id: "" }],
      assessList: [],
      allClientList: [],
      clientLevelList: [],
      regionList: [],
      number: 10,
      currentPage: 1,
      totalCount: 0,
      selectedAll: false,
      totalPage: 1,
      fileType: 2,
      oldFileType: 2,
      is_showData: true,
      collect_type: "",
      form: {
        search_text: "",
        // province_id: "",
      },
      _index: "",
      showType: "new", // 选择的tab栏，new新流程 old旧流程
      is_new_system: 1, // 是否新企业 1新 0旧
    };
  },
  props: {
    clientId: {
      type: Number,
    },
  },
  async created() {
    await this._getPage(1);
    //获取省份数据
    regionList().then((res) => {
      if (0 === res.status) {
        this.regionList = res.data.regionList;
      } else {
        this.regionList = [];
      }
    });
    this.is_new_system = this.$store.state.companyInfo.webscrap_is_new
  },
  methods: {
    openModal(info, collect_type) {
      this.info = info ? [...info] : [];
      this.collect_type = collect_type;
      this.right = Array.isArray(info) ? [...info] : [];
      
      if (this.right.length && this.right[0]) {
        this.selectedAll = this.right[0].client_name === "全部";
      } else {
        this.selectedAll = false;
      }
      
      this.visible = true;
      this._getPage(1);
    },
    //获取列表
    async _getPage(page) {
      if (this.collect_type == 1) {
        let parm = { ...this.form };
        parm.page = page;
        parm.is_new_system = this.is_new_system;
        parm.collect_type = this.collect_type;
        parm.function_status = 1;
        await getClientPage(parm).then((res) => {
          if (0 === res.status) {
            let list = res.data.list;
            this.allClientList = [...list];
            this.left = [...list];
            this._filterLeft();
            this.totalCount = parseInt(res.data.totalCount) || 0;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = parseInt(res.data.totalPage);
          } else {
            this.left = [];
            this.totalCount = 0;
          }
        });
      } else if (this.collect_type == 3) {
        let parm = { ...this.form };
        parm.page = page;
        parm.collect_type = this.collect_type;
        await ftpPage(parm).then((res) => {
          if (0 === res.status) {
            let list = res.data.list;
            this.allClientList = [...list];
            this.left = [...list];
            this._filterLeft();
            this.totalCount = parseInt(res.data.totalCount) || 0;
            this.currentPage = parseInt(res.data.currentPage);
            this.totalPage = parseInt(res.data.totalPage);
          } else {
            this.left = [];
            this.totalCount = 0;
          }
        });
      }
    },
    onSearch(val) {
      this._getPage(1);
    },
    leftSelect(id) {
      const left = this.left;
      const target = left.filter((item) => item.client_id === id)[0];
      this.right.push(target);
      this.left = left.filter((item) => item.client_id !== id);
    },
    rightDelete(item) {
      if (item.client_name != "全部") {
        const right = this.right;
        const target = right.filter(
          (item1) => item1.client_id === item.client_id
        )[0];
        this.right = right.filter(
          (item1) => item1.client_id !== item.client_id
        );
        this.left.push(target);
      } else {
        this.removeAll();
      }
    },
    save() {
      this.info = [...this.right];
      this.$emit("save", this.info, this.is_new_system);
      this.visible = false;
      this.form = {};
    },
    cencel() {
      this.visible = false;
      this.form = {};
    },
    _filterLeft() {
      let right = this.right;
      let rightIds = [];
      
      // 如果right为空,直接返回
      if (!right || right.length === 0) {
        return;
      }

      for (let item of right) {
        // 检查item是否存在
        if (!item) continue;

        if (item.client_id) {
          if (Array.isArray(item.client_id)) {
            rightIds.push(...item.client_id);
          } else {
            rightIds.push(item.client_id);
          }
        }

        // 检查是否有全部选项
        if (item.subsidiary_name === "全部") {
          this.left = [];
          this.selectedAll = true;
          return;
        }
      }

      // 过滤左侧列表
      if (rightIds.length > 0) {
        this.left = this.left.filter(
          (item) => rightIds.indexOf(item.client_id) === -1
        );
      }
    },
    selectAll() {
      this.is_showData = true;
      this.selectedAll = true;
      this.right = [
        {
          client_array: this.left,
          client_id: this.left.map((item) => item.client_id),
          client_name: "全部",
        },
      ];
      this.left = [];
    },
    removeAll() {
      this.is_showData = false;
      this.selectedAll = false;
      this.right = [];
      this.left = this.allClientList;
    },
    onChangePage(pageNumber) {
      this._getPage(pageNumber);
    },
    //取消
    cancel() {
      let obj = this.info;
      let arr = [];
      for (let i in obj) {
        arr.push(obj[i]);
      }
      this.$emit("save", arr);
      this.visible = false;
    },
    // handleClick(e) {
    //   this.showType = e.name;
    //   this.search_text = "";
    //   this.is_new_system = e.name == "new" ? 1 : 0;
    //   this.right = [];
    //   this.form = {};
    //   this.selectedAll = false;
    //   this._getPage(1);
    // }
  },
};
</script>

<style scoped lang="scss">
.icon-close {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;

  &:hover {
    color: #000;
  }
}

.box {
  display: inline-block;
  vertical-align: middle;

  &.left,
  &.right {
    position: relative;
    padding-top: 34px;
    width: 330px;
    height: 400px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .header {
      padding: 6px 12px;
      border-radius: 4px 4px 0 0;
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      border-bottom: 1px solid #e8e8e8;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .list-body {
      position: relative;
      height: 100%;
      font-size: 14px;

      .list-content {
        padding: 0;
        padding-top: 42px;
        height: 100%;
        overflow: auto;
        list-style: none;
        margin: 0;
      }
    }
  }

  &.left {
    .list-item {
      cursor: pointer;
    }
  }

  &.middle {
    overflow: hidden;
    margin: 0 8px;
  }
}

.view-filter {
  margin-bottom: 20px;
}

.list-item {
  position: relative;
  overflow: hidden;
  /*white-space: nowrap;*/
  text-overflow: ellipsis;
  min-height: 32px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  list-style: none;

  &:hover {
    background-color: #e6f7ff;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    padding: 10px;
    width: 49%;
    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
    &:last-of-type {
      width: 50%;
    }
  }

  &.right {
    padding-right: 32px;
  }
}

.list-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  z-index: 2;

  span {
    background: #fafafa;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
}
</style>
